module.exports = __webpack_public_path__ + "img/futurama-amy-wong.b0719838.png";